export const BUTTON_DISABLED_TOOLTIP_MESSAGE = '權限不足'

// 這個區塊是從 accessToken 中解析出來的 scope，屬於使用者權限，無關組織
export const WITHOUT_USER_SCOPE_EDIT_DATA_MESSAGE = '實名制未通過'
export const USER_SCOPE_EDIT_DATA = 'edit_data'

export const ORG_EDIT_SCOPE = 'org:edit' // 編輯組織
export const ORG_CLONE_SCOPE = 'org:clone' // 複製組織
export const ORG_REMOVE_SCOPE = 'org:remove' // 刪除組織
export const ORG_TRANSFER_DATA_SCOPE = 'org:transfer_data' // 轉移組織資料
export const USER_EDIT_SCOPE = 'user:edit' // 編輯用戶 v
export const USER_REMOVE_SCOPE = 'user:remove' // 刪除用戶
export const ROLE_EDIT_SCOPE = 'role:edit' // 編輯角色
export const ROLE_REMOVE_SCOPE = 'role:remove' // 刪除角色
export const PLATFORM_BILL_LIST_SCOPE = 'platform:bill:list' // 查看帳單
export const BILL_TAKEOUT_LIST_SCOPE = 'bill:takeout_list' // 查看帳單
export const BILL_TAKEOUT_SCOPE = 'bill:takeout' // 提領帳單 v
export const OBJECT_LIST_SCOPE = 'object:list' // 查看物件 v
export const OBJECT_CREATE_SCOPE = 'object:edit'
export const OBJECT_REMOVE_SCOPE = 'object:remove' // 刪除物件
export const TAG_EDIT_SCOPE = 'tag:edit' // 編輯標籤
export const TAG_REMOVE_SCOPE = 'tag:remove' // 刪除標籤
export const CONTRACT_LIST_SCOPE = 'contract:list' // 查看合約 v
export const CONTRACT_EDIT_SCOPE = 'contract:edit' // 編輯合約
export const CONTRACT_REMOVE_SCOPE = 'contract:remove' // 刪除合約
export const CONTRACT_SIGNING_SCOPE = 'contract:signing' // 合約簽署
export const REPAIR_LIST_SCOPE = 'repair:list' // 查看維修
export const REPAIR_EDIT_SCOPE = 'repair:edit' // 編輯維修
export const REPAIR_REMOVE_SCOPE = 'repair:remove' // 刪除維修
export const BILL_LIST_SCOPE = 'bill:list' // 查看帳單 v
export const BILL_EDIT_SCOPE = 'bill:edit' // 編輯帳單
export const BILL_REMOVE_SCOPE = 'bill:remove' // 刪除帳單
export const MANAGEMENT_REPORT_LIST_SCOPE = 'management:report:list' // 查看管理報表
export const MANAGEMENT_REPORT_EXPORT_EXCEL_SCOPE =
    'management:report:export_excel' // 匯出Excel (管理報表)
export const EXPENSE_LIST_SCOPE = 'expense:list' // 查看支出 v
export const EXPENSE_EDIT_SCOPE = 'expense:edit' // 編輯支出
export const EXPENSE_REMOVE_SCOPE = 'expense:remove'
export const IOT_DEVICE_LIST_SCOPE = 'iot_device:list' // 查看物聯網設備
export const IOT_DEVICE_EDIT_SCOPE = 'iot_device:edit' // 編輯物聯網設備 v
export const IOT_DEVICE_REMOVE_SCOPE = 'iot_device:remove' // 刪除物聯網設備
export const IOT_DEVICE_CHARGE_AMOUNT_SCOPE = 'iot_device:charge_amount' // 計費
export const PLUGIN_CUSTOMER_WEBSITE_BRAND_EDIT_SCOPE =
    'plugin:customer_website:brand:edit' // 編輯品牌
export const PLUGIN_CUSTOMER_WEBSITE_OBJECT_EDIT_SCOPE =
    'plugin:customer_website:object:edit' // 編輯物件
export const PLUGIN_INVOICE_MANAGE_INVOICE_LIST_SCOPE =
    'plugin:invoice_manage:invoice:list' // 查看發票
export const PLUGIN_INVOICE_MANAGE_INVOICE_CREATE_SCOPE =
    'plugin:invoice_manage:invoice:create' // 新增發票
export const PLUGIN_INVOICE_MANAGE_INVOICE_REVOKE_SCOPE =
    'plugin:invoice_manage:invoice:revoke' // 作廢發票
export const PLUGIN_CLIENT_SERVICE_FEE_ORG_EDIT_SCOPE =
    'plugin:client_service_fee:org:edit' // 編輯客戶服務費
export const PLUGIN_CLIENT_SERVICE_FEE_OBJECT_EDIT_SCOPE =
    'plugin:client_service_fee:object:edit' // 編輯客戶服務費
// 社宅權限
export const PLUGIN_AFFORDABLE_HOUSE_CONTRACT_LIST_SCOPE =
    'plugin:affordable_house:contract:list' // 查看案源媒合文件 v
// export const SOCIAL_HOUSE_CASE_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_REMOVE_SCOPE = 'plugin:affordable_house:contract:remove' // 刪除案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_REMOVE_SCOPE = 'plugin:affordable_house:contract:remove' // 刪除案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_DOCUMENT_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_PDF_RELEASE_SCOPE = 'plugin:affordable_house:pdf:release' // 去除文件浮水印
export const PLUGIN_AFFORDABLE_HOUSE_REPORT_EXPORT_EXCEL_SCOPE = 'plugin:affordable_house:report:export_excel' // 匯出Excel (媒合匯出)
export const PLUGIN_AFFORDABLE_HOUSE_INVENTORY_EDIT_SCOPE = 'plugin:affordable_house:inventory:edit' // 編輯清冊
export const PLUGIN_AFFORDABLE_HOUSE_INVENTORY_REVOKE_SCOPE = 'plugin:affordable_house:inventory:contract_release:revoke' // 作廢清冊
export const PLUGIN_AFFORDABLE_HOUSE_FINANCIAL_CONTROL_EDIT_SCOPE = 'plugin:affordable_house:financial_control:edit' // 編輯金融控管

export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_LIST_SCOPE =
    'plugin:property_owner_manage:property_owner:list' // 查看物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_EDIT_SCOPE =
    'plugin:property_owner_manage:property_owner:edit' // 編輯物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_REMOVE_SCOPE =
    'plugin:property_owner_manage:property_owner:remove' // 刪除物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_SET_WARNING_SCOPE =
    'plugin:property_owner_manage:property_owner:set_warning' // 設定物業所有者警告
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_LIST_SCOPE =
    'plugin:property_owner_manage:event:list' // 查看事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_EDIT_SCOPE =
    'plugin:property_owner_manage:event:edit' // 編輯事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_REMOVE_SCOPE =
    'plugin:property_owner_manage:event:remove' // 刪除事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_REPORT_EXPORT_EXCEL_SCOPE =
    'plugin:property_owner_manage:report:export_excel' // 匯出Excel (事件)
export const PLATFORM_PAYMENT_CREDIT_CARD_BIND_SCOPE =
    'platform:payment:credit_card_bind' // 綁定信用卡
export const ORG_EXIT_SCOPE = 'org:exit'
// 權限分組資料結構
export const PERMISSION_GROUPS = [
    {
        group: '組織管理',
        items: [
            {
                title: '組織設定',
                desc: '設定組織操作權限',
                scopes: [
                    {
                        value: ORG_EDIT_SCOPE,
                        label: '編輯組織',
                        desc: '變更組織資料',
                    },
                    {
                        value: ORG_CLONE_SCOPE,
                        label: '複製組織',
                        desc: '建立相同設定的組織',
                    },
                    {
                        value: ORG_TRANSFER_DATA_SCOPE,
                        label: '轉移資料',
                        desc: '將物件移出/移入',
                    },
                    {
                        value: ORG_REMOVE_SCOPE,
                        label: '刪除組織',
                        desc: '移除未使用的組織',
                    },
                ],
            },
            {
                title: '成員管理',
                desc: '管理組織成員',
                scopes: [
                    {
                        value: USER_EDIT_SCOPE,
                        label: '編輯成員',
                        desc: '邀請新成員、變更成員角色',
                    },
                    {
                        value: USER_REMOVE_SCOPE,
                        label: '移除成員',
                        desc: '移除後將無法查看相關資料',
                    },
                ],
            },
            {
                title: '角色管理',
                desc: '調整角色相關功能',
                scopes: [
                    {
                        value: ROLE_EDIT_SCOPE,
                        label: '編輯角色',
                        desc: '建立新角色、變更角色權限',
                    },
                    {
                        value: ROLE_REMOVE_SCOPE,
                        label: '移除角色',
                        desc: '僅能移除未使用角色',
                    },
                ],
            },
            {
                title: '系統費',
                desc: 'Bananas上使用數據',
                scopes: [
                    {
                        value: PLATFORM_BILL_LIST_SCOPE,
                        label: '查看消費紀錄',
                        desc: '每月有效用量、發票、戶數紀錄',
                    },
                ],
            },
            {
                title: '提領中心',
                desc: '查看提領紀錄',
                scopes: [
                    {
                        value: BILL_TAKEOUT_LIST_SCOPE,
                        label: '提領中心',
                        desc: '查看提領紀錄',
                    },
                    {
                        value: BILL_TAKEOUT_SCOPE,
                        label: '錢包提領',
                        desc: '申請帳金撥款',
                    },
                ],
            },
        ],
    },
    {
        group: '租賃事業',
        items: [
            {
                title: '物件管理',
                desc: '查看物件',
                scopes: [
                    {
                        value: OBJECT_LIST_SCOPE,
                        label: '物件管理',
                        desc: '查看物件',
                    },
                    {
                        value: OBJECT_CREATE_SCOPE,
                        label: '編輯物件',
                        desc: '建立/編輯物件、指派成員',
                    },
                    {
                        value: OBJECT_REMOVE_SCOPE,
                        label: '刪除物件',
                        desc: '移除未使用的物件',
                    },
                    {
                        value: TAG_EDIT_SCOPE,
                        label: '編輯標籤',
                        desc: '建立/編輯標籤',
                    },
                    {
                        value: TAG_REMOVE_SCOPE,
                        label: '刪除標籤',
                        desc: '移除已建立標籤',
                    },
                ],
            },
            {
                title: '合約管理',
                desc: '查看合約',
                scopes: [
                    {
                        value: CONTRACT_LIST_SCOPE,
                        label: '合約管理',
                        desc: '查看合約',
                    },
                    {
                        value: CONTRACT_EDIT_SCOPE,
                        label: '編輯合約',
                        desc: '建立/編輯合約、合約繳費方式',
                    },
                    {
                        value: CONTRACT_REMOVE_SCOPE,
                        label: '刪除合約',
                        desc: '移除未使用的合約',
                    },
                    {
                        value: CONTRACT_SIGNING_SCOPE,
                        label: '執行簽約',
                        desc: '發起簽約、編約、終止合約及驗證合約',
                    },
                ],
            },
            {
                title: '維修管理',
                desc: '查看維修、工單、維修供應商',
                scopes: [
                    {
                        value: REPAIR_LIST_SCOPE,
                        label: '維修管理',
                        desc: '查看維修、工單、維修供應商',
                    },
                    {
                        value: REPAIR_EDIT_SCOPE,
                        label: '編輯維修資料',
                        desc: '建立/編輯維修、工單、維修供應商',
                    },
                    {
                        value: REPAIR_REMOVE_SCOPE,
                        label: '刪除維修資料',
                        desc: '移除維修、工單、維修供應商',
                    },
                ],
            },
            {
                title: '帳單管理',
                desc: '查看帳單',
                scopes: [
                    {
                        value: BILL_LIST_SCOPE,
                        label: '帳單管理',
                        desc: '查看帳單',
                    },
                    {
                        value: BILL_EDIT_SCOPE,
                        label: '編輯帳單',
                        desc: '建立/編輯帳單(含人工對帳)',
                    },
                    {
                        value: BILL_REMOVE_SCOPE,
                        label: '刪除帳單',
                        desc: '移除帳單',
                    },
                    {
                        value: MANAGEMENT_REPORT_LIST_SCOPE,
                        label: '統計數據',
                        desc: 'BMS帳單統計資料',
                    },
                    {
                        value: MANAGEMENT_REPORT_EXPORT_EXCEL_SCOPE,
                        label: '匯出報表',
                        desc: 'BMS下載帳單報表、物件報表',
                    },
                ],
            },
            {
                title: '支出管理',
                desc: '查看支出',
                scopes: [
                    {
                        value: EXPENSE_LIST_SCOPE,
                        label: '支出管理',
                        desc: '查看支出',
                    },
                    {
                        value: EXPENSE_EDIT_SCOPE,
                        label: '編輯支出',
                        desc: '建立/編輯支出',
                    },
                    {
                        value: EXPENSE_REMOVE_SCOPE,
                        label: '刪除支出',
                        desc: '移除支出',
                    },
                ],
            },
            {
                title: 'IoT 設備管理',
                desc: '查看 IoT 設備',
                scopes: [
                    {
                        value: IOT_DEVICE_LIST_SCOPE,
                        label: 'IoT 設備管理',
                        desc: '查看 IoT 設備',
                    },
                    {
                        value: IOT_DEVICE_EDIT_SCOPE,
                        label: '編輯設備',
                        desc: '建立/編輯設備',
                    },
                    {
                        value: IOT_DEVICE_REMOVE_SCOPE,
                        label: '刪除設備',
                        desc: '移除設備',
                    },
                    {
                        value: IOT_DEVICE_CHARGE_AMOUNT_SCOPE,
                        label: '加值設定',
                        desc: '手動加值指定設備、變更加值設定',
                    },
                ],
            },
        ],
    },
    {
        group: '插件管理',
        items: [
            {
                title: '品牌網站',
                desc: '設定品牌網站',
                scopes: [
                    {
                        value: PLUGIN_CUSTOMER_WEBSITE_BRAND_EDIT_SCOPE,
                        label: '編輯品牌網站',
                        desc: '上傳 logo、填寫品牌故事',
                    },
                    {
                        value: PLUGIN_CUSTOMER_WEBSITE_OBJECT_EDIT_SCOPE,
                        label: '編輯品牌物件',
                        desc: '管理物件資訊、上/下架',
                    },
                ],
            },
            {
                title: '發票管理',
                desc: '查看和開立發票',
                scopes: [
                    {
                        value: PLUGIN_INVOICE_MANAGE_INVOICE_LIST_SCOPE,
                        label: '開立發票',
                        desc: '允許開立發票',
                    },
                    {
                        value: PLUGIN_INVOICE_MANAGE_INVOICE_CREATE_SCOPE,
                        label: '發票作廢',
                        desc: '允許作廢發票',
                    },
                    {
                        value: PLUGIN_INVOICE_MANAGE_INVOICE_REVOKE_SCOPE,
                        label: '發票作廢',
                        desc: '允許作廢發票',
                    },
                ],
            },
            {
                title: '服務費管理',
                desc: '匯出合約服務費的報表',
                scopes: [
                    {
                        value: PLUGIN_CLIENT_SERVICE_FEE_ORG_EDIT_SCOPE,
                        label: '預設方案',
                        desc: '變更組織預設服務費方案',
                    },
                    {
                        value: PLUGIN_CLIENT_SERVICE_FEE_OBJECT_EDIT_SCOPE,
                        label: '合約服務費方案',
                        desc: '變更合約指定的服務費方案',
                    },
                ],
            },
            {
                title: '社宅合約',
                desc: '允許查看社宅資訊',
                scopes: [
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_CONTRACT_LIST_SCOPE,
                        label: '編輯案源、媒合、文件',
                        desc: '建立/編輯案源、媒合、文件',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_CASE_EDIT_SCOPE,
                        label: '刪除案源、媒合',
                        desc: '移除案源、媒合',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_CASE_REMOVE_SCOPE,
                        label: '去除文件浮水印',
                        desc: '去除浮水印',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_PDF_RELEASE_SCOPE,
                        label: '匯出媒合',
                        desc: '下載指定案名的報表',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_REPORT_EXPORT_EXCEL_SCOPE,
                        label: '製作清冊',
                        desc: '匯出法人、項目及案主清冊',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_INVENTORY_EDIT_SCOPE,
                        label: '作廢文件',
                        desc: '將行動申請表文件、移出清冊',
                    },
                    {
                        value: PLUGIN_AFFORDABLE_HOUSE_INVENTORY_REVOKE_SCOPE,
                        label: '匯出報表',
                        desc: 'BMS下載帳單報表、物件報表',
                    },
                ],
            },
            {
                title: '業主管理',
                desc: '允許查看業主列表',
                scopes: [
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_LIST_SCOPE,
                        label: '編輯業主',
                        desc: '變更業主資料',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_EDIT_SCOPE,
                        label: '變更警示狀態',
                        desc: '設定/解除警示',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_REMOVE_SCOPE,
                        label: '刪除業主',
                        desc: '移除業主資料',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_SET_WARNING_SCOPE,
                        label: '編輯事件',
                        desc: '建立/編輯業主事件',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_LIST_SCOPE,
                        label: '刪除事件',
                        desc: '移除業主事件',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_EDIT_SCOPE,
                        label: '匯出報表',
                        desc: '下載業主事件報表',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_REMOVE_SCOPE,
                        label: '電查查詢',
                        desc: '檢視歷史電查報表',
                    },
                    {
                        value: PLUGIN_PROPERTY_OWNER_MANAGE_REPORT_EXPORT_EXCEL_SCOPE,
                        label: '電查查詢',
                        desc: '檢視歷史電查報表',
                    },
                ],
            },
        ],
    },
]
